import SEO from '../components/SEO/SEO'
import Layout from '../layout/Layout'
import ContactForm from '../components/ContactForm/ContactForm'

const RequestToJoin = () => {
  return (
    <>
      <SEO />
      <Layout>
        <div className="relative">
          <div className="absolute inset-x-0 bottom-0 h-1/2 bg-gray-100" />
          <div className="mx-auto">
            <div className="relative">
              <div className="absolute inset-0">
                <img
                  className="h-full w-full object-cover"
                  src="homepage-hero-background.png"
                  alt="People working on laptops"
                />
              </div>
              <div className="relative px-4 py-16 sm:px-6 sm:py-24 lg:py-32 lg:px-32">
                <h1 className=" text-4xl font-extralight tracking-tight sm:text-5xl lg:text-6xl">
                  <span className="block text-blue-dark">
                    Request to Join the
                  </span>
                  <span className="block text-globeGreen">Evry Network</span>
                </h1>
              </div>
            </div>
          </div>
        </div>

        <section className="mb-12">
          <ContactForm />
        </section>
      </Layout>
    </>
  )
}

export default RequestToJoin
